import { TemplatePage } from './types';

const animatedPage: TemplatePage = {
  header: {
    color: '#FFDC74',
    icon: 'images/video-templates/trending-animated.jpg',
    title: 'Animated Video Templates Collection',
    title_meta: '50+ Free Editable Animated Video Templates',
    description_meta:
      'Wow your audience with Wave.video’s 50+ easy-to-edit animated video templates.',
    description:
      'Step up your video marketing game with these 50+ easy-to-edit animated video templates. Wow your audience with ' +
      'beautiful animated videos that will leave a lasting impression.'
  },
  footer: {
    category: 'Animated',
    description:
      'With Wave.video’s wide range of professionally designed animated video templates, you can create beautiful videos ' +
      'for your website, blog, social media, or email newsletter in a matter of minutes. All the templates are easy and free ' +
      'to customize to suit your brand’s goals.'
  },
  content: [
    {
      type: 'templates',
      title: 'Animated Video Templates',
      search: { name: 'animated' }
    },
    {
      type: 'stocks',
      title: 'animated',
      search: { name: 'animated' }
    },
    { type: 'calendar' }
  ]
};

export default animatedPage;
